import artBackground from '../../assets/background/IMG_8365.webp';
import HeroBanner, { hexToRgbList } from '../../page_assets/HeroBanner';

// The flat navy IMG_8365's dragonfly floats on, sampled off the photo itself.
export const FIELD = '#00207F';

// The same navy the header takes its fill from over this landing — see
// page_assets/header.
export const FIELD_RGB = hexToRgbList(FIELD);

/**
 * The art portfolio's landing. Everything about how it behaves is HeroBanner's; what's
 * here is this page's own photo, palette and copy.
 *
 * The heading doubles as the gallery's section nav, driven off the same list the radial
 * wheel is, so a category that empties out of the asset folders leaves both.
 *
 * @param sections          [{ name }] in gallery order
 * @param onSelectSection   (index) => void — scrolls to that category's first row
 */
export default function ArtHeroSection({ sections = [], onSelectSection }) {
    return (
        <HeroBanner
            backgroundImage={artBackground}
            field={FIELD}
            ink="#E11D2E"
            titleInk="#f7db00"
            title={{ script: 'art', text: 'Portfolio', syllables: ['por', 'tfo', 'lio'], scriptFirst: true }}
            sections={sections.map((section, index) => ({
                key: section.name,
                label: section.name,
                onSelect: () => onSelectSection?.(index),
            }))}
            body="I work across graphic design and marketing, and have taken multiple national
                awards for web and graphic design. Alongside that I have spent five years on
                freelance art and commissions, including large-scale murals."
        />
    );
}
